let CollapsibleTextComponent = function () {
    const classMap = {
        css: {
            expanded: "pcg-collapsible-text--expanded",
            collapsed: "pcg-collapsible-text--collapsed"
        },
        js: {
            toggle: ".js-collapsible-text__toggle",
            content: ".js-collapsible-text__content"
        }
    };

    let $currentContext = $();
    let $toggle, $content;

    let expanded = false;

    function getMaxHeight() {
        return $currentContext.data().maxHeight;
    }

    function toggle() {
        expanded = !expanded;

        let targetHeight = expanded ? "100%" : getMaxHeight();
        $content.css("max-height", targetHeight);

        $currentContext.toggleClass(classMap.css.expanded, expanded);
        $currentContext.toggleClass(classMap.css.collapsed, !expanded);
    }

    function truncateContent() {
        let maxHeight = getMaxHeight();
        $content.css("max-height", maxHeight);
    }

    function showToggle() {
        $toggle.show();
    }

    function allowToggle() {
        let maxHeight = getMaxHeight();
        let outerHeight = $content.outerHeight();
        return outerHeight > maxHeight;
    }

    function bindEvents() {
        $toggle.on("click", function () {
            toggle();
        })
    }

    function setCurrentView() {
        if(allowToggle()) {
            truncateContent();
            showToggle();
        }
    }

    function parseContext() {
        $toggle = $(classMap.js.toggle, $currentContext);
        $content = $(classMap.js.content, $currentContext);
    }

    this.init = function (context) {
        $currentContext = context || $currentContext;

        parseContext();
        setCurrentView();
        bindEvents();
    };
};

Object.defineProperty(CollapsibleTextComponent, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-collapsible-text"
});

module.exports = CollapsibleTextComponent;
